import { Header } from './Modal.styles.js';
import { type HTMLAttributes } from 'react';

type ModalHeaderProps = HTMLAttributes<HTMLDivElement> & {
  readonly flex?: boolean;
  readonly marginForCloseButton?: boolean;
};

const ModalHeader = ({
  children,
  flex = false,
  marginForCloseButton = false,
}: ModalHeaderProps) => {
  return (
    <Header
      $flex={flex}
      $marginForCloseButton={marginForCloseButton}
    >
      {children}
    </Header>
  );
};

ModalHeader.displayName = 'Modal.Header';

export { ModalHeader };
